
import { BasicModel } from "@goodgamestudios/core";
import { BasicRegisterDialogProperties } from "@goodgamestudios/core";
import { BasicUserEvent } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { TextValide } from "@goodgamestudios/core";

import { TextField } from "@goodgamestudios/createjs-utilities";

import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { AvatarCreationEvent } from "../../../event/AvatarCreationEvent";
import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2NameSelection } from "../Poker2NameSelection";

import Container = createjs.Container;
import Event = createjs.Event;
import FocusEvent = createjs.FocusEvent;
import MouseEvent = createjs.MouseEvent;
import TextEvent = createjs.TextEvent;
import Rectangle = createjs.Rectangle;

export class Poker2RegisterSocialDialog extends Poker2Dialog {
    public static NAME: string = "Poker2RegisterSocialDialog";
    private isWaitingForServerMessage: boolean = false;
    private preset_name: string = "";
    private nameSelectionToolTip: Poker2NameSelection;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected init(): void {
        super.init();
        this.controller.addEventListener(BasicUserEvent.REGISTERED, this.bindFunction(this.onRegisterCompleted));
        this.controller.addEventListener("avatarnamesuggestions", this.bindFunction(this.onShowNameSuggestion));
        this.controller.addEventListener("registerFailed", this.bindFunction(this.onRegisterFailed));

        this.registerDialog.txt_name.tabIndex = 1;
        this.registerDialog.txt_name.addEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onEnterUsername));
        this.registerDialog.txt_name.addEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterUsername));
        this.registerDialog.txt_name.addEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.refillEmptyInputFields));
        this.registerDialog.txt_name.maxChars = this.env.maxUsernameLength;
        this.registerDialog.txt_name.condenseWhite = true;

        this.preset_name = (Poker2Model.userData.guestName != "") ? Poker2Model.userData.guestName : this.env.displayName.slice(0, this.env.maxUsernameLength);
        this.initTextFields();
    }

    protected applyProperties(): void {
        this.isWaitingForServerMessage = false;
        this.registerDialog.txt_name.text = this.preset_name;
        this.drawAvatar();
    }

    private drawAvatar(): void {
        while (this.registerDialog.mc_holder.numChildren > 0)
            this.registerDialog.mc_holder.removeChildAt(0);
        if (Poker2Model.avatarData.myAvatar == null) {
            // todo: show Dummy
            return;
        }
        var mcAvatar: Container = AvatarHelper.drawAvatarByItemArray(Poker2Model.avatarData.getAvatarClothesArray(Poker2Model.avatarData.myAvatar), true);
        var bounds: Rectangle = mcAvatar.getBounds(null);

        /*			var scaleFactor:Number = ( 130/bounds.width );
                    if ( (180/bounds.height) > scaleFactor )
                        scaleFactor = ( 180/bounds.height );
                    mcAvatar.scaleX = mcAvatar.scaleY = scaleFactor;
                    mcAvatar.x = - ((bounds.width*scaleFactor)/2 + (bounds.left*scaleFactor));
                    mcAvatar.y = - (bounds.top*scaleFactor);*/

        var scaleFactor: number = (155 / bounds.width);
        if ((210 / bounds.height) > scaleFactor)
            scaleFactor = (210 / bounds.height);
        mcAvatar.scaleX = mcAvatar.scaleY = scaleFactor;
        mcAvatar.x = - ((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        mcAvatar.y = - (bounds.top * scaleFactor);

        this.registerDialog.mc_holder.addChild(mcAvatar);
    }

    private onEnterUsername(event: Event): void {
        if (this.registerDialog.txt_name.text == this.preset_name)
            this.registerDialog.txt_name.text = "";
    }

    private refillEmptyInputFields(event: Event = null): void {
        if (this.registerDialog.txt_name.text == "")
            this.registerDialog.txt_name.text = this.preset_name;
    }

    private initTextFields(): void {
        this.registerDialog.btn_register.minWidth = 80;
        this.registerDialog.btn_register.label = Poker2Model.languageData.getTextById("generic_register_letsgo");

        this.registerDialog.txt_title.text = Poker2Model.languageData.getTextById("generic_login_register");
        this.registerDialog.btn_avatar.toolTiptext = Poker2Model.languageData.getTextById("login_btn_changeavatar");
        this.registerDialog.btn_avatar.visible = Poker2Model.avatarData.myAvatar != null;
    }

    protected onClick(event: MouseEvent): void {
        if (this.isWaitingForServerMessage)
            return;
        super.onClick(event);
        if (this.isLocked) {
            if (event.target == this.registerDialog.txt_name)
                this.hideNameSelection();
            return;
        }
        switch (event.target) {
            case this.registerDialog.btn_register:
                this.onPlayNow();
                break;
            case this.registerDialog.btn_avatar:
                this.hide();
                this.layoutManager.showDialog("Poker2AvatarCreationDialog");
                break;
            case this.registerDialog.txt_name:
                (event.target as TextField).setSelection(0, (event.target as TextField).text.length);
                break;
        }
    }

    /**
     * Play as Guest
     */
    private onPlayNow(): void {
        if (this.isWaitingForServerMessage)
            return;
        if (!TextValide.isSmartFoxValide(this.registerDialog.txt_name.text)) {
            this.showErrorBubble(28);
            //				layoutManager.showDialog( "Poker2WarningDialog",
            //					new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_register_title"), Poker2Model.languageData.getTextById("generic_register_namenotvalid")));
            return;
        }

        this.isWaitingForServerMessage = true;
        //			BasicModel.smartfoxClient.sendMessage( "lpn", [JSON.stringify( { name: registerDialog.txt_name.text } )]);
        BasicModel.smartfoxClient.sendMessage("lgr", []);
    }

    public show(): void {
        super.show();
        this.hideNameSelection();
    }
    private onRegisterFailed(e: Poker2UserEvent): void {
        this.isWaitingForServerMessage = false;
        this.showErrorBubble(e.params[0]);
    }

    private showErrorBubble(error: number): void {
        switch (error) {
            case 28:
                TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.registerDialog.mc_errorbubble.txt_title, Poker2Model.languageData.getTextById("generic_alert_watchout"));
                TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.registerDialog.mc_errorbubble.txt_copy, Poker2Model.languageData.getTextById("alert_invalid_name"), 4);
                break;
            default:
                TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.registerDialog.mc_errorbubble.txt_title, Poker2Model.languageData.getTextById("generic_alert_watchout"));
                TextFieldHelper.changeTextFromatSizeByTextWidth(10, this.registerDialog.mc_errorbubble.txt_copy, Poker2Model.languageData.getTextById("errorcode_" + error), 4);
                break;
        }
        this.registerDialog.mc_errorbubble.visible = true;
    }

    private onRegisterCompleted(e: BasicUserEvent): void {
        this.isWaitingForServerMessage = false;
        this.hide();
    }

    private onShowNameSuggestion(event: AvatarCreationEvent): void {
        this.lockDialog();
        this.isWaitingForServerMessage = false;
        if (this.nameSelectionToolTip == null) {
            this.nameSelectionToolTip = new Poker2NameSelection(new Library.PokerInterface.AvatarNameSelection(), this.registerDialog.mc_name);
            this.registerDialog.mc_name.addChild(this.nameSelectionToolTip.disp);
            this.nameSelectionToolTip.disp.y = 5;
            this.nameSelectionToolTip.disp.x = 10;
        }
        this.nameSelectionToolTip.showNames(event.params[0]);
        this.nameSelectionToolTip.disp.addEventListener("avatarnameselected", this.bindFunction(this.onNameSelected));
    }
    private onNameSelected(event: AvatarCreationEvent): void {
        this.hideNameSelection();
        this.nameSelectionToolTip.disp.removeEventListener("avatarnameselected", this.bindFunction(this.onNameSelected));
        this.registerDialog.txt_name.text = event.params.shift();
    }
    private hideNameSelection(): void {
        if (this.nameSelectionToolTip)
            this.nameSelectionToolTip.hide();
        this.registerDialog.mc_errorbubble.visible = false;
        this.unLockDialog();
    }

    public destroy(): void {
        this.controller.removeEventListener(BasicUserEvent.REGISTERED, this.bindFunction(this.onRegisterCompleted));
        this.controller.removeEventListener("avatarnamesuggestions", this.bindFunction(this.onShowNameSuggestion));
        this.controller.removeEventListener("registerFailed", this.bindFunction(this.onRegisterFailed));
        this.hideNameSelection();

        this.registerDialog.txt_name.removeEventListener(TextEvent.TEXT_INPUT, this.bindFunction(this.onEnterUsername));
        this.registerDialog.txt_name.removeEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onEnterUsername));
        this.registerDialog.txt_name.removeEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.refillEmptyInputFields));
        super.destroy();
    }

    protected get registerDialogProperties(): BasicRegisterDialogProperties {
        return this.properties as BasicRegisterDialogProperties;
    }

    protected get registerDialog(): Library.PokerInterface.PokerRegisterSocial {
        return this.disp as Library.PokerInterface.PokerRegisterSocial;
    }
}
import { AvatarHelper } from "../../helper/AvatarHelper";
import { Poker2AvatarCreationDialog } from "./Poker2AvatarCreationDialog";
